import { Card, CardContent } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { generarEncabezados } from './funciones';


const ValidarTarifario = () => {
  const FECHA_INICIAL  = new Date(2022, 11, 1)
  const FECHA_FINAL =new Date(2023, 1, 29)
 console.log("Data", FECHA_INICIAL)

 const data =  generarEncabezados(FECHA_INICIAL, FECHA_FINAL,1)

 console.log("Data", data)
  return (
    <Card>
      <CardContent>
              <h1>validar tarifario</h1>
        </CardContent>
      </Card>
  );
}

export default ValidarTarifario;